import ImageNotAllowedException from "./ImageNotAllowedException";
import { imageHasTag } from "@/react/components/Template/common";
import { PictureTag } from "../../Webshop/types/PictureSet";
import i18n from "i18next";
import { getUserResources } from "@/react/Providers/TemplateInstanceProvider";
class ImageAllowedValidator {
    constructor(template, options) {
        this.template = template;
        this.options = options;
    }
    imageAllowedInAnyResource(file) {
        console.log("Checking allowed in any resource", file, this.template, this.options);
        let allowedInAtLeastOneResource = false;
        const resources = getUserResources(this.template);
        for (const resource of Object.values(resources)) {
            console.log("Checking allowed resource", resource);
            if ("type" in resource &&
                resource.type === "IMAGE" &&
                resource.userSupplied) {
                try {
                    this.checkLockedToTag(file, resource);
                    this.imageAllowedInTemplate(file);
                    allowedInAtLeastOneResource = true;
                    break;
                }
                catch (_er) {
                    console.log("Image allowed error", _er);
                }
            }
        }
        console.log("Allowed in at least one resource", allowedInAtLeastOneResource);
        if (!allowedInAtLeastOneResource) {
            throw new ImageNotAllowedException();
        }
    }
    imageAllowedInResource(file, imageResource) {
        this.checkLockedToTag(file, imageResource);
        this.imageAllowedInTemplate(file);
    }
    validateGroupPicture(file) {
        this.checkNotAllowed(file, PictureTag.GroupPicture, this.options.disableGroupPicturesInCategories || [], i18n.t("Group pictures cannot be inserted into portrait picture templates"));
    }
    validateMiniGroupPicture(file) {
        this.checkNotAllowed(file, PictureTag.MiniGroupPicture, this.options.disableMiniGroupPicturesInCategories || [], i18n.t("Sibling and friend pictures cannot be inserted into this template"));
    }
    validatePortraitPicture(file) {
        this.checkNotAllowed(file, PictureTag.IndividualPicture, this.options.disablePortraitPicturesInCategories || [], i18n.t("Portrait pictures cannot be inserted into group picture templates"));
    }
    checkNotAllowed(file, tag, categoryList, errorMessage) {
        if (categoryList.length === 0 || !file.keywords.includes(tag)) {
            return;
        }
        categoryList.forEach((category) => {
            if (this.template.categories.includes(category)) {
                throw new ImageNotAllowedException(errorMessage);
            }
        });
        // Additional checks for CARDS/CALENDARS
        if (this.template.type === "CALENDAR" &&
            categoryList.includes("CALENDARS")) {
            throw new ImageNotAllowedException(errorMessage);
        }
        if (this.template.type === "CARD" && categoryList.includes("CARDS")) {
            throw new ImageNotAllowedException(errorMessage);
        }
    }
    checkLockedToTag(file, imageResource) {
        var _a;
        if (!imageResource.lockedToTag &&
            !((_a = this.options.lockedImageTags) !== null && _a !== void 0 ? _a : []).includes(imageResource.tag)) {
            return;
        }
        const tag = imageResource.tag;
        if (!imageHasTag(file, tag)) {
            const error = i18n.t("You can't use the picture in this container");
            throw new ImageNotAllowedException(error);
        }
    }
    customGroupPictureChecks(file) {
        if (this.template.categories.indexOf("GROUPPICTURES") >= 0) {
            if (this.options.groupPictureCategoryRequirePictureToBeInLandscapeFormat &&
                file.size.width < file.size.height) {
                const error = i18n.t("Group pictures have to be in landscape format");
                throw new ImageNotAllowedException(error);
            }
        }
        else if (this.template.categories.indexOf("COMPOSITEPHOTO") >= 0) {
            if (this.options.compositeCategoryRequirePictureToBeInPortraitFormat &&
                file.size.width > file.size.height) {
                const error = i18n.t("Composite pictures have to be in portrait format");
                throw new ImageNotAllowedException(error);
            }
        }
    }
    imageAllowedInTemplate(file) {
        this.validateGroupPicture(file);
        this.validateMiniGroupPicture(file);
        this.validatePortraitPicture(file);
        this.customGroupPictureChecks(file);
    }
}
export default ImageAllowedValidator;
